/** The session request: SessionProvider asks it on every load, which is when a session learns the language. */
export const SESSION_PATH = '/api/v1/me';

const PUBLIC_PREFIX = '/api/v1/public/';

/**
 * A GET that carries the reader's language as `lang`: every public read, and the session request.
 *
 * The backend keeps the language in the HTTP session (SessionLocaleResolver, Romanian by default)
 * and changes it on any request that carries `lang`; Accept-Language is never read. Public reads
 * need it for their content. The session request needs it for everything else: sent on each load
 * — after signing in too — it sets the session's language, and the server then writes its refusals
 * in it. The cabinet's other requests are left alone; the session already knows.
 *
 * A URL that already names a `lang` keeps it: the caller asked for that one on purpose.
 */
export function withLanguageParam(method: string, url: string, language: string | null): string {
  if (method !== 'GET' || !language) return url;
  const path = url.split('?')[0];
  if (!path.startsWith(PUBLIC_PREFIX) && path !== SESSION_PATH) return url;
  if (/[?&]lang=/.test(url)) return url;
  return url + (url.includes('?') ? '&' : '?') + 'lang=' + encodeURIComponent(language);
}
